import { makeStyles } from "tss-react/mui";

export type IStyleParams = {
  locale: string;
  required: boolean;
  isError: boolean;
  width: string;
};

const useStyles = makeStyles<{ params: IStyleParams }>({
  name: "AppInput",
  uniqId: "app_input",
})((theme, { params }, classes) => {
  return {
    formControl: {
      width: params.width,
      height: "fit-content",

      "& .MuiInputBase-root": {
        color: "#ADADAD",
        minWidth: "fit-content",
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
        padding: "0 10px",
        gap: 8,
        width: params.width,

        "& input": {
          color: "#00000080",
        },
      },

      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: params.isError ? "red" : "#DBD4E6",
        borderWidth: "1px",
        borderStyle: "solid",
        borderRadius: "0px",
      },

      "& .MuiFormLabel-asterisk": {
        color: "#FF3747",
        fontFamily: params.locale === "en-US" ? "Montserrat" : params.locale === "zh-CN" ? "Noto Sans SC" : "Noto Sans TC",
        fontSize: "18px",
        fontStyle: "normal",
        fontWeight: "700",
        lineHeight: "200%",
        // letterSpacing: "3.6px",
        // textTransform: "uppercase",
      },
    },

    labelText: {
      color: "#333",
      textAlign: "center",
      fontFamily: params.locale === "en-US" ? "Montserrat" : params.locale === "zh-CN" ? "Noto Sans SC" : "Noto Sans TC",
      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "200%",
      letterSpacing: params.locale === "en-US" ? 0 : "3.6px",
      // textTransform: "uppercase",
    },

    textField: {
      color: "#333",
      textAlign: "center",
      fontFamily: params.locale === "en-US" ? "Montserrat" : params.locale === "zh-CN" ? "Noto Sans SC" : "Noto Sans TC",
      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "normal",
      letterSpacing: params.locale === "en-US" ? 0 : "1.8px",
      width: params.width,
    },

    "& .MuiOutlinedInput-root": {
      border: "",
    },
  };
});

export default useStyles;
